import { http } from '@pendo/http';

export function fetchProductLines (subscriptionId = '_SID_') {
    return http.get(`/api/s/${subscriptionId}/productline`).then((res) => res.data);
}

/*
 *   Product line endpoints are case sensitive
 *  /api/s/${subId}/productline/sessionReplay != /api/s/${subId}/productline/sessionReplay
 */

export function fetchProductLineByType (subId = '_SID_', type) {
    return http.get(`/api/s/${subId}/productline/${type}`).then((res) => res.data);
}

export function setFlagForType ({ type, flag, set, subId = '_SID_' }) {
    return http.put(`/api/s/${subId}/productline/${type}/${flag}`, { set }).then((res) => res.data);
}

export function setProductLineMetadata ({ type, data, subId = '_SID_' }) {
    return http.put(`/api/s/${subId}/productline/${type}/metadata`, { ...data }).then((res) => res.data);
}

export function updateProductLineMetadata ({ subscriptionId, productType, productLineMetadata }) {
    return http
        .put(`/api/super/s/${subscriptionId}/productline/${productType}/metadata`, productLineMetadata)
        .then((res) => res.data);
}
